<template>
    <HLCardLayout :useFixedHeight="false" :scale="(isXsDevice)?1:(isXlDevice)?0.4:(isTabletOrPhone)?((isInLandscape)?0.9:0.7):0.7"  :horizontalMargin="isLgAndUpDevice" :disablePadding="isXsDevice">
        <template #content>
            <HLFormLoginRegister @next="onLoginSuccess" :enableRegisterByDefault="false"/>
        </template>
    </HLCardLayout>
</template>

<script>
import HLCardLayout from "../../components/dashboard/HLCardLayout";
import HLFormLoginRegister from "../../components/auth/HLFormLoginRegister";
import {layoutMixin} from "../../utils/layout-mixin";
import {settingsMixin} from "../../utils/settings-mixin";
import {eventMixin} from "../../utils/event-mixin";
import {qrLoginMixin} from "../../utils/qrlogin-mixin";
import {onboardingMixin} from "../../utils/onboarding-mixin";

export default {
    mixins: [layoutMixin,settingsMixin,eventMixin,qrLoginMixin,onboardingMixin],
    components:{
        HLCardLayout,
        HLFormLoginRegister
    },
    data: () => ({
    }),
    computed: {
    },
    methods: {
        onLoginSuccess(){
            this.landAfterLogin();
        }
    }
}
</script>

<style scoped>

.container{
    max-width: 600px;
}
</style>